import React, { useState } from 'react';
import { Box, Typography, Grid, Divider, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import atto2 from './images/atto2/car-green.png';
import ti7 from './images/ti7/car-jadegreen.png';
import { createWhatsAppUrl } from './siteConfig';
import m6 from './Asset/m6-blue-fix-fixed.webp';
import atto from './Asset/atto3-white-fix.webp';
import seal from './Asset/seal-fix.webp';
import sealion7 from './Asset/byd-sealion-7-2.webp';
import denzad9 from './Asset/danza-d9.webp';
import seagull from './Asset/seagull.webp';
import z9gt from './images/z9gt/z9gt-pricing.jpg';
import m6dm from './images/bydm6dm/menu-1.webp';
import PageSeo, {
  absoluteUrl,
  breadcrumbJsonLd,
  keywordSets,
  localBusinessJsonLd,
} from './PageSeo';
import { m6DmVariants } from './m6DmData';
import { vehiclePrices } from './vehiclePrices';

const getVariantPrices = (variants) =>
  variants
    .map((variant) => Number(String(variant.price).replace(/\D/g, '')))
    .filter((price) => Number.isFinite(price) && price > 0)
    .sort((a, b) => a - b);

function Pricing() {
  const [selectedVariants, setSelectedVariants] = useState({});

  const vehicles = [
    {
      name: 'DANZA Z9 GT',
      image: z9gt,
      isNew: true,
      variants: [
        {
          ...vehiclePrices.z9gt[0],
          details: [
            { label: 'Penggerak', value: 'Three-Motor AWD' },
            { label: 'Tenaga Sistem Maksimum', value: '1.156 PS / 850 kW' },
            { label: 'Torsi Sistem Maksimum', value: '1.210 Nm' },
            { label: '0-100 km/jam', value: '2,7 detik' },
            { label: 'Kecepatan Maksimum', value: '240 km/jam' },
            { label: 'Baterai', value: 'Blade Battery Gen 2 (LFP) + CTB' },
            { label: 'Kapasitas Baterai', value: '122,49 kWh' },
            { label: 'Jarak Tempuh (NEDC)', value: '701 km' },
            { label: 'Pengisian DC', value: 'BYD Flash Charging' },
            { label: 'Pengisian AC', value: '11 kW' },
            { label: 'Dimensi (P x L x T)', value: '5.180 x 1.990 x 1.490 mm' },
            { label: 'Wheelbase', value: '3.125 mm' },
            { label: 'Radius Putar', value: '4,62 m' },
            { label: 'Bagasi Depan', value: '53 L' },
            { label: 'Bagasi Belakang', value: '495 / 1.680 L' },
            { label: 'Warna', value: 'Fjord Green, Obsidian Black, Snow White, Porcelain Blue' },
          ],
        },
      ],
    },
    {
      name: 'BYD M6 DM',
      image: m6dm,
      isNew: true,
      variants: m6DmVariants.map((variant) => ({
        ...variant,
        description: `${variant.price} | OTR Jakarta`,
        details: [
          { label: 'Teknologi', value: 'Dual Mode Plug-in Hybrid' },
          { label: '0-100 km/h', value: '10.1 detik' },
          { label: 'Kapasitas Baterai', value: '18 kWh' },
          { label: 'Kapasitas Tangki', value: '52 liter' },
          { label: 'Range (NEDC)', value: '1200 km' },
          { label: 'Karakter', value: 'Mobil listrik yang bisa diisi bensin' },
        ],
      })),
    },
    {
      name: 'BYD ATTO 1',
      image: seagull,
      isNew: true,
      variants: [
        {
          ...vehiclePrices.atto1[0],
          details: [{ label: 'NIK', value: '2026' }],
        },
        {
          ...vehiclePrices.atto1[1],
          details: [
            { label: 'NIK', value: '2026' },
            { label: 'Jarak Tempuh (NEDC)', value: '300 km' },
            { label: 'Kapasitas Baterai', value: '30.08 kWh' },
            { label: 'Tenaga Maksimum', value: '55 kW' },
            { label: 'Torsi Maksimum', value: '135 Nm' },
            { label: 'Akselerasi 0-50 km/h', value: '4.9 detik' },
            { label: 'Kecepatan Maksimum', value: '130 km/h' },
            { label: 'Pengisian DC', value: '30 kW (30–80% ±30 menit)' },
            { label: 'Pengisian AC', value: '6.6 kW' },
            { label: 'Ukuran Ban', value: '185/55 R16' },
            { label: 'Berat Kosong', value: '1.225 kg' },
            { label: 'Jumlah Airbag', value: '4' },
            { label: 'Kunci Digital', value: 'NFC + Bluetooth' },
            { label: 'Spion Electric / Retract Mirror', value: 'Ada' },
            { label: 'Kursi Pengemudi', value: 'Electric 6-way' },
            { label: 'Shift Mechanism', value: 'Shift by Wire' },
            { label: 'Warna Spion', value: 'Hitam' },
            { label: 'Headliner', value: 'Non-woven fabric' },
            {
              label: 'Layar',
              value: '10.1" fixed PAD, CarPlay, Android Auto',
            },
            { label: 'Defogger Spion', value: 'Tidak tersedia' },
            { label: 'Defogger Kaca Belakang', value: 'Tidak tersedia' },
          ],
        },
        {
          ...vehiclePrices.atto1[2],
          details: [
            { label: 'NIK', value: '2026' },
            { label: 'Jarak Tempuh (NEDC)', value: '380 km' },
            { label: 'Kapasitas Baterai', value: '38.88 kWh' },
            { label: 'Tenaga Maksimum', value: '55 kW' },
            { label: 'Torsi Maksimum', value: '135 Nm' },
            { label: 'Akselerasi 0-50 km/h', value: '4.9 detik' },
            { label: 'Kecepatan Maksimum', value: '130 km/h' },
            { label: 'Pengisian DC', value: '40 kW (30–80% ±30 menit)' },
            { label: 'Pengisian AC', value: '6.6 kW' },
            { label: 'Ukuran Ban', value: '185/55 R16' },
            { label: 'Berat Kosong', value: '1.280 kg' },
            { label: 'Jumlah Airbag', value: '4' },
            { label: 'Kunci Digital', value: 'NFC + Bluetooth' },
            { label: 'Spion Electric / Retract Mirror', value: 'Ada' },
            { label: 'Kursi Pengemudi', value: 'Electric 6-way' },
            { label: 'Kamera 360', value: 'Ada' },
            { label: 'Shift Mechanism', value: 'Shift by Wire' },
            { label: 'Headliner', value: 'Non-woven fabric' },
            {
              label: 'Layar',
              value: '10.1" fixed PAD, CarPlay, Android Auto',
            },
            { label: 'Defogger Spion', value: 'Tidak tersedia' },
            { label: 'Defogger Kaca Belakang', value: 'Tidak tersedia' },
            { label: 'Wireless Charging', value: '✔️' },
          ],
        },
      ],
    },
    {
      name: 'BYD TI7',
      image: ti7,
      isComingSoon: true,
      isPreBook: true,
      path: '/jelajahi-ti7',
      comingSoonNote:
        'SUV 7-seater pertama BYD dengan DM-p Super Hybrid AWD. Pre-book sudah dibuka, harga resmi Indonesia menyusul.',
      variants: [],
    },
    {
      name: 'BYD ATTO 2',
      image: atto2,
      isComingSoon: true,
      isPreBook: true,
      path: '/jelajahi-atto2',
      comingSoonNote:
        'SUV kompak listrik dengan Blade Battery 2.0 dan Flash Charging. Pre-book sudah dibuka, harga resmi Indonesia menyusul.',
      variants: [],
    },
    {
      name: 'BYD DANZA D9',
      image: denzad9,
      isNew: true,
      variants: [
        {
          ...vehiclePrices.denzaD9[0],
          details: [
            { label: 'NIK', value: '2026 (2nd Generation)' },
            { label: 'Penggerak', value: 'FWD (motor tunggal)' },
            { label: 'Tenaga Maksimum', value: '340 kW' },
            { label: 'Torsi Maksimum', value: '365 Nm' },
            { label: 'Kapasitas Baterai', value: '115,07 kWh (Blade Battery 2.0)' },
            { label: 'Jarak Tempuh (NEDC)', value: '730 km' },
            { label: 'Akselerasi 0-100 km/jam', value: '8,5 detik' },
            { label: 'Flash Charging', value: '0-97% ±9 menit' },
            { label: 'Suspensi', value: 'DiSus-C' },
            { label: 'Audio', value: 'Devialet 16 speaker' },
            { label: 'Airbag', value: '9' },
            { label: 'Kursi Pijat Baris 2', value: '10 titik' },
            { label: 'Kursi Baris 3', value: 'Elektrik 4 arah' },
            { label: 'Kapasitas Bagasi', value: '689 L (2.436 L dilipat)' },
            { label: 'Dimensi (P x L x T)', value: '5.250 x 1.960 x 1.900 mm' },
            { label: 'Wheelbase', value: '3.110 mm' },
            { label: 'Radius Putar', value: '5,85 m' },
            { label: 'Ban', value: 'Bridgestone HL 235/60 R18' },
            { label: 'Warna Eksterior', value: 'Cosmos Black, Arctic White, Starry Night Grey, Whale Sea Blue' },
            { label: 'Pilihan Interior', value: 'Brown, Black (baru)' },
          ],
        },
      ],
    },
    {
      name: 'BYD SEALION 7',
      image: sealion7,
      variants: vehiclePrices.sealion7,
    },
    {
      name: 'BYD SEAL',
      image: seal,
      variants: vehiclePrices.seal,
    },
    {
      name: 'BYD ATTO 3',
      image: atto,
      variants: [
        {
          ...vehiclePrices.atto3[0],
          details: [
            { label: 'Kapasitas Baterai', value: '49.92 kWh' },
            { label: 'Daya Maksimum', value: '150 kW' },
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: '0-100 km/h', value: '7.9 s' },
            { label: 'Jarak Tempuh NEDC', value: '410 km' },
            { label: 'Pengisian DC', value: '70 kW (30–80% ~45 menit)' },
          ],
        },
      ],
    },
    {
      name: 'BYD M6',
      image: m6,
      variants: [
        {
          ...vehiclePrices.m6[0],
          details: [
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: 'Daya Maksimum', value: '120 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '420 km' },
            { label: 'Kapasitas Baterai', value: '55.4 kWh' },
            { label: '0-100 km/h', value: '10.1 s' },
          ],
        },
        {
          ...vehiclePrices.m6[1],
          details: [
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: 'Daya Maksimum', value: '150 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '530 km' },
            { label: 'Kapasitas Baterai', value: '71.8 kWh' },
            { label: '0-100 km/h', value: '8.6 s' },
          ],
        },
        {
          ...vehiclePrices.m6[2],
          details: [
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: 'Daya Maksimum', value: '150 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '530 km' },
            { label: 'Kapasitas Baterai', value: '71.8 kWh' },
            { label: '0-100 km/h', value: '8.6 s' },
          ],
        },
      ],
    },
  ];

  const pricedVehicles = vehicles
    .map((vehicle) => ({
      vehicle,
      prices: getVariantPrices(vehicle.variants),
    }))
    .filter(({ prices }) => prices.length > 0);

  const pricingJsonLd = [
    localBusinessJsonLd(),
    breadcrumbJsonLd([
      { name: 'Beranda', path: '/' },
      { name: 'Harga Mobil BYD', path: '/pricing' },
    ]),
    {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      name: 'Daftar Harga Mobil BYD dan Danza di BYD BSD Serpong',
      itemListElement: pricedVehicles.map(({ vehicle, prices }, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: vehicle.name,
          image: absoluteUrl(vehicle.image),
          brand: {
            '@type': 'Brand',
            name: vehicle.name.includes('DANZA') ? 'Danza' : 'BYD',
          },
          offers: {
            '@type': 'AggregateOffer',
            priceCurrency: 'IDR',
            lowPrice: prices[0],
            highPrice: prices[prices.length - 1],
            offerCount: prices.length,
            availability: 'https://schema.org/InStock',
            seller: {
              '@id': 'https://bydbsdserpong.com/#dealer',
            },
          },
        },
      })),
    },
  ];

  return (
    <Box
      component='main'
      sx={{
        px: { xs: 2, sm: 4 },
        pt: { xs: 12, sm: 14 },
        pb: { xs: 8, sm: 10 },
        boxSizing: 'border-box',
        minHeight: 'calc(100vh - 260px)',
      }}
    >
      <PageSeo
        title='Harga BYD NIK 2026 BSD Serpong | Atto 1 Mulai Rp199 Juta'
        description='Harga NIK 2026: Atto 1 mulai Rp199 juta, M6 EV mulai Rp395 juta, Atto 3 Advanced Plus Rp415 juta, Sealion 7 Rp879 juta, Seal Rp869 juta, Danza D9 Rp1,08 miliar, dan Danza Z9 GT Rp2,25 miliar.'
        keywords={[
          ...keywordSets.pricing,
          ...keywordSets.danza,
          'harga BYD Tangerang Selatan',
          'price list BYD BSD',
          'price list Danza',
          'pre-book BYD Ti7',
          'pre-book BYD Atto 2',
        ]}
        path='/pricing'
        image={z9gt}
        jsonLd={pricingJsonLd}
      />

      <Typography
        variant='h1'
        component='h1'
        fontWeight='bold'
        sx={{
          textAlign: 'center',
          marginBottom: 4,
          fontSize: { xs: '2rem', sm: '2.5rem' },
        }}
      >
        Daftar Harga
      </Typography>

      <Typography sx={{ textAlign: 'center', color: '#555', mb: 3 }}>
        Harga diperbarui Oktober 2026 · OTR Jakarta
      </Typography>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Button
          component={RouterLink}
          to='/jelajahi-ti7'
          sx={{ textTransform: 'none', fontWeight: 700 }}
        >
          Open Pre-Book: BYD Ti7 & BYD Atto 2 · Harga resmi menyusul
        </Button>
      </Box>
      <Divider sx={{ marginBottom: 4 }} />

      <Grid container spacing={4}>
        {vehicles.map((vehicle, index) => {
          const selectedIndex = selectedVariants[vehicle.name] || 0;
          const selectedVariant = vehicle.variants[selectedIndex];

          return (
            <Grid item xs={12} sm={6} key={index} sx={{ display: 'flex' }}>
              <Box
                component='article'
                aria-label={vehicle.name}
                sx={{
                  textAlign: 'center',
                  position: 'relative',
                  padding: { xs: 2, sm: 4 },
                  backgroundColor: '#f9f9f9',
                  borderRadius: '12px',
                  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                  width: '100%',
                  height: { xs: 'auto', md: 900 },
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                {vehicle.isNew && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      backgroundColor: '#e53935',
                      color: '#fff',
                      fontSize: 12,
                      fontWeight: 'bold',
                      px: 1,
                      py: 0.3,
                      borderRadius: '4px',
                      animation: 'blinker 1s linear infinite',
                      boxShadow: '0 0 6px rgba(255,0,0,0.6)',
                      zIndex: 2,
                    }}
                  >
                    🔥 HOT! NEW!
                  </Box>
                )}

                <Box
                  sx={{
                    position: 'relative',
                    width: '80%',
                    height: { xs: 170, sm: 210, md: 230 },
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: '0 0 auto',
                  }}
                >
                  <Box
                    component='img'
                    src={vehicle.image}
                    loading='lazy'
                    sx={{
                      display: 'block',
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </Box>

                <Typography
                  variant='h5'
                  fontWeight='bold'
                  sx={{
                    fontSize: { xs: '1.5rem', sm: '2rem' },
                    minHeight: { sm: 52 },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {vehicle.name}
                </Typography>

                {vehicle.isComingSoon ? (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 1.5,
                      mt: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        display: 'inline-block',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: '999px',
                        backgroundColor: vehicle.isPreBook ? '#fbf1cf' : '#eaf8fb',
                        color: vehicle.isPreBook ? '#8a6d1d' : '#0077a6',
                        fontWeight: 800,
                        fontSize: '0.8rem',
                        letterSpacing: 0.6,
                      }}
                    >
                      {vehicle.isPreBook ? 'OPEN PRE-BOOK' : 'COMING SOON'}
                    </Typography>
                    <Typography
                      variant='h5'
                      fontWeight='bold'
                      sx={{ fontSize: { xs: '1.3rem', sm: '1.6rem' } }}
                    >
                      Harga resmi menyusul
                    </Typography>
                    {vehicle.comingSoonNote && (
                      <Typography
                        variant='body2'
                        sx={{ color: '#555', maxWidth: 420, lineHeight: 1.6 }}
                      >
                        {vehicle.comingSoonNote}
                      </Typography>
                    )}
                    {vehicle.path && (
                      <Button
                        component={RouterLink}
                        to={vehicle.path}
                        variant='contained'
                        color='primary'
                        sx={{ textTransform: 'none', fontWeight: 600 }}
                      >
                        Lihat detail
                      </Button>
                    )}
                    <Button
                      variant='outlined'
                      color='primary'
                      href={createWhatsAppUrl(
                        `Halo Junius, saya ingin pre-book ${vehicle.name}. Mohon info ketentuan tanda jadi, pilihan warna, dan estimasi pengiriman.`,
                      )}
                      target='_blank'
                      rel='noopener noreferrer'
                      sx={{ textTransform: 'none', fontWeight: 600 }}
                    >
                      Pre-book via WhatsApp
                    </Button>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      flex: 1,
                      minHeight: 0,
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                        marginBottom: 2,
                        minHeight: { sm: 132 },
                        alignContent: 'flex-start',
                      }}
                    >
                      {vehicle.variants.map((variant, idx) => (
                        <Box
                          key={idx}
                          component='button'
                          type='button'
                          aria-pressed={idx === selectedIndex}
                          onClick={() => {
                            setSelectedVariants((prev) => ({
                              ...prev,
                              [vehicle.name]: idx,
                            }));
                          }}
                          sx={{
                            border:
                              idx === selectedIndex
                                ? '2px solid #1976d2'
                                : '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            textAlign: 'center',
                            minWidth: '150px',
                            minHeight: 78,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            font: 'inherit',
                            backgroundColor:
                              idx === selectedIndex ? '#e3f2fd' : 'transparent',
                            transition: '0.2s ease',
                          }}
                        >
                          <Typography
                            variant='body1'
                            fontWeight='bold'
                            sx={{ fontSize: '1rem', marginBottom: 1 }}
                          >
                            {variant.type}
                          </Typography>
                          <Typography variant='body2' sx={{ color: '#555' }}>
                            {variant.description}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    <Typography
                      variant='h5'
                      fontWeight='bold'
                      sx={{
                        marginBottom: 1,
                        fontSize: { xs: '1.5rem', sm: '1.8rem' },
                      }}
                    >
                      {selectedVariant.price}
                    </Typography>

                    <Typography
                      variant='body2'
                      sx={{ marginBottom: 2, color: '#888' }}
                    >
                      {selectedVariant.price === 'Coming Soon'
                        ? 'Harga resmi menyusul'
                        : vehicle.name === 'BYD M6 DM'
                          ? 'OTR Jakarta (IDR) | Harga Juli 2026'
                          : 'OTR Jakarta (IDR) | Harga NIK 2026'}
                    </Typography>

                    {selectedVariant.dressUp && (
                      <Box
                        sx={{
                          mt: 2,
                          mb: 2,
                          p: 1.5,
                          borderRadius: '10px',
                          background:
                            'linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%)',
                          border: '1px solid #f4d06f',
                          textAlign: 'left',
                          maxWidth: '100%',
                        }}
                      >
                        <Typography
                          variant='subtitle2'
                          sx={{
                            fontWeight: 700,
                            color: '#8a6d1d',
                            mb: 1,
                            textAlign: 'center',
                            fontSize: '0.95rem',
                          }}
                        >
                          🎁 {selectedVariant.dressUp.title}
                        </Typography>

                        <Box
                          component='img'
                          src={selectedVariant.dressUp.image}
                          alt='ATTO 1 Dress Up Package'
                          sx={{
                            width: '100%',
                            maxHeight: 260,
                            objectFit: 'contain',
                            borderRadius: '8px',
                            mb: 1.2,
                            display: 'block',
                            border: '1px solid rgba(0,0,0,0.08)',
                            backgroundColor: '#fffdf5',
                          }}
                        />

                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                            gap: 0.5,
                          }}
                        >
                          {selectedVariant.dressUp.items.map((item, idx) => (
                            <Typography
                              key={idx}
                              variant='caption'
                              sx={{
                                color: '#444',
                                fontSize: '0.78rem',
                                lineHeight: 1.4,
                              }}
                            >
                              • {item}
                            </Typography>
                          ))}
                        </Box>

                        <Typography
                          variant='caption'
                          sx={{
                            display: 'block',
                            mt: 1,
                            color: '#7a7a7a',
                            textAlign: 'center',
                            fontSize: '0.72rem',
                          }}
                        >
                          Paket aksesoris mengikuti program dan ketersediaan.
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ marginBottom: 2 }} />

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        minHeight: 0,
                      }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          minHeight: 0,
                          overflowY: { xs: 'visible', md: 'auto' },
                          pr: { md: 1 },
                          mr: { md: -1 },
                          scrollbarWidth: 'thin',
                        }}
                      >
                        {selectedVariant.details.map((detail, idx) => (
                          <Box key={idx}>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                minHeight: 40,
                                paddingX: 2,
                                marginBottom: 1,
                                gap: 2,
                              }}
                            >
                              <Typography
                                variant='body1'
                                sx={{
                                  flex: '1 1 50%',
                                  fontSize: { xs: '0.9rem', sm: '1rem' },
                                  color: '#555',
                                  textAlign: 'left',
                                }}
                              >
                                {detail.label}
                              </Typography>
                              <Typography
                                variant='body2'
                                sx={{
                                  flex: '1 1 50%',
                                  fontSize: { xs: '1rem', sm: '1.1rem' },
                                  fontWeight: 600,
                                  textAlign: 'right',
                                }}
                              >
                                {detail.value}
                              </Typography>
                            </Box>
                            <Divider />
                          </Box>
                        ))}
                      </Box>

                      <Button
                        variant='contained'
                        color='primary'
                        fullWidth
                        href={`https://api.whatsapp.com/send?phone=6281286864825&text=Halo%2C%20saya%20tertarik%20dengan%20${encodeURIComponent(
                          vehicle.name,
                        )}%20tipe%20${encodeURIComponent(
                          selectedVariant.type,
                        )}.%20Mohon%20info%20harga%20dan%20promonya.`}
                        target='_blank'
                        sx={{
                          mt: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: { xs: '0.95rem', sm: '1rem' },
                        }}
                      >
                        Pesan Sekarang via WhatsApp
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <style>
        {`
          @keyframes blinker {
            0% { opacity: 1; }
            50% { opacity: 0.1; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </Box>
  );
}

export default Pricing;
